var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcoAccountClosure = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 16.004,
    viewBox: "0 0 18 16.004",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "ico_account_closure",
    d: "M609.521,283.67a3.549,3.549,0,1,1-3.386,3.7c0-.053,0-.106,0-.159A3.469,3.469,0,0,1,609.521,283.67ZM611,294.8a5.409,5.409,0,0,1,1.167-3.364.968.968,0,0,0-.52.2,3.282,3.282,0,0,1-4.217-.02.928.928,0,0,0-.809-.189,6.173,6.173,0,0,0-3.73,5.339c-.092.833.346,2.864,6.613,2.894a16.689,16.689,0,0,0,3.886-.361,5.446,5.446,0,0,1-2.39-4.5Zm5.436-4.45a4.445,4.445,0,1,0,4.445,4.445A4.45,4.45,0,0,0,616.436,290.355Zm2.1,6.016a.371.371,0,0,1-.524.524l-1.571-1.571-1.571,1.571a.371.371,0,0,1-.524-.524l1.571-1.571-1.571-1.572a.37.37,0,0,1,.524-.523l1.571,1.571,1.571-1.571a.37.37,0,1,1,.524.523L616.96,294.8Z",
    transform: "translate(-602.881 -283.666)",
    fill: "#8d939c"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcoAccountClosure);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ico_account_closure.3aafb01b3138dae9b5cbbdfd37d958a2.svg";